(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skin-concerns"] && !Shopify.designMode) return;
  try {
    
const heroSection = document.querySelector('[data-hero]');
if (heroSection) {
  const tabButtons = heroSection.querySelectorAll('[data-block-id]');
  const backgroundImages = heroSection.querySelectorAll('[data-bg-id]');

  const activateTab = (btn) => {
    const blockId = btn.getAttribute('data-block-id');
    if (!blockId) return;

    // Check if this tab has a background image
    const targetImage = heroSection.querySelector(`[data-bg-id="${blockId}"]`);
    
    // ❗ If image is NOT found — STOP, do not change bg
    if (!targetImage) return;

    // Update active tab
    tabButtons.forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    // Show only the matched background
    backgroundImages.forEach(img => img.classList.remove('is-active'));
    targetImage.classList.add('is-active');
  };

  tabButtons.forEach(btn => {
    btn.addEventListener('mouseenter', () => activateTab(btn));
  });
}

  } catch(e) { console.error(e); }
})();
})();
